import { CloudflareAsset } from "@/shared/common/enums";
import type { IDetailAction } from "@/shared/common/types";
import { ActionItem, CloudFlareImage } from "@/shared/components";
import { useScroll } from "@/shared/hooks";
import { Button } from "@ab.uitools/ui-library/components/Button";
import type { ISVGIconProps } from "@ab.uitools/ui-library/components/SVGIcons/types";

interface Props {
  actions: IDetailAction[];
  page: string;
}

export const DetailActions = ({ actions, page }: Props) => {
  const {
    isAtEnd,
    isAtStart,
    scrollContainerRef,
    onHorizontalScroll,
  } = useScroll();
  return (
    <div className="position-relative mt-40 mb-20">
      <div ref={scrollContainerRef} className="service-items-wrapper">
        {!isAtStart && (
          <div className="arrow-wrapper left-overlay">
            <Button
              onClick={() => onHorizontalScroll("left")}
              type="secondary"
              size="medium"
              data-testid="detail-action-left-scroll"
              data-ga-id="detail-action-left-scroll"
              data-ga-action={`${page} actions left scroll button`}
              iconProps={{
                Component: (props: ISVGIconProps) => (
                  <CloudFlareImage {...props} path={CloudflareAsset.ArrowShortLeft}/>
                ),
              }}
            />
          </div>
        )}
        <div className="full-width flexbox">
          {actions?.map((action) => (
            <div key={action.id} className="pr-16">
              <ActionItem
                title={action.title}
                icon={action.icon as CloudflareAsset}
                onClick={action.onClick}
              />
            </div>
          ))}
        </div>
        {!isAtEnd && (
          <div className="arrow-wrapper right-overlay">
            <Button
              onClick={() => onHorizontalScroll("right")}
              type="secondary"
              size="medium"
              data-testid="detail-action-right-scroll"
              data-ga-id="detail-action-right-scroll"
              data-ga-action={`${page} actions right scroll button`}
              iconProps={{
                Component: (props: ISVGIconProps) => (
                  <CloudFlareImage {...props} path={CloudflareAsset.ArrowShortRight}/>
                ),
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
};
